import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShoppingBag1"><Path d="M15.5 7.5C15.5 9.433 13.933 11 12 11C10.067 11 8.5 9.433 8.5 7.5M4.5 3.5L3.5 20.5H20.5L19.5 3.5H4.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShoppingBag1;
